import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { FORM_SCHEMAS } from "@/lib/forms";

export function useSubmit(kind) {
  const [loading, setLoading] = useState(false);

  const submit = async (payload, onSuccess) => {
    const schema = FORM_SCHEMAS[kind];
    if (!schema) throw new Error(`Unknown form kind: ${kind}`);
    const base = process.env.REACT_APP_BACKEND_URL;
    if (!base) {
      toast.error("Configuration error.", { description: "Backend URL is not set." });
      return false;
    }
    setLoading(true);
    try {
      await axios.post(`${base}/api/${schema.path}`, payload);
      toast.success("Received — our team will reach out shortly.", {
        description: "Thanks for connecting with ApexLink.",
      });
      onSuccess?.();
      return true;
    } catch (e) {
      console.error("Form submit failed:", e);
      toast.error("Something went wrong.", {
        description: "Please check your details and try again.",
      });
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { loading, submit };
}
